import { GPTGameLauncher } from 'src/EXPERIMENTAL_LIB/modules/gpt/games';
import { GptGameButtonProps } from '../types';
import { GPTGameButton } from './GPTGameButton';

export const FruitBonanzaButton = ({ isCollapsed }: GptGameButtonProps) => {
  return (
    <GPTGameLauncher
      toShow
      gameName="oneReelSlot"
      renderButton={(props) => <GPTGameButton {...props} isCompact={isCollapsed} />}
      authOnly={false}
    />
  );
};
